import { h, Component, createRef } from "preact";
import Cleave from "cleave.js";
import omit from "lodash/omit";
import isEqual from "lodash/isEqual";

import { getCleaveConfig } from "../helpers";
import TextField from "./TextField.jsx";

export default class CurrencyField extends Component {
  cleave = null;
  ref = createRef();

  state = {
    isUpdating: false,
    value: this.props.value,
  };

  handleValueChange = (event) => {
    if (this.state.isUpdating) return;

    this.setState({ value: event.target.value });

    this.props.onUpdate && this.props.onUpdate(event.target.rawValue);
    this.props.onChange && this.props.onChange(event.target.rawValue);
  };

  componentDidMount() {
    const localeConfig = getCleaveConfig(
      window.navigator.language.replace("-", "_")
    );

    const element = this.ref.current.base.querySelector("input");
    this.cleave = new Cleave(element, {
      numeral: true,
      ...(localeConfig.style === "lakh"
        ? {
            numeralThousandsGroupStyle: "lakh",
          }
        : {
            numeralThousandsGroupStyle: "thousand",
            numeralDecimalMark: localeConfig.dec,
            delimiter: localeConfig.sep,
          }),
      onValueChanged: this.handleValueChange,
    });
  }

  componentWillUnmount() {
    this.cleave.destroy();
  }

  shouldComponentUpdate(nextProps, nextState) {
    // If nothing changed, nothing to do
    if (
      isEqual(omit(nextProps, "value"), omit(this.props, "value")) &&
      nextState.value === this.state.value
    ) {
      return false;
    }

    // Only update if the numbers don't match
    return (
      nextState.value !== this.state.value ||
      nextProps.value !== this.props.value ||
      nextProps.currency !== this.props.currency ||
      (nextProps.value || "") !== this.cleave.getRawValue()
    );
  }

  render() {
    // Disabled the currency options stuff for now. Not clear how to handle it, and we don't need it yet.
    return (
      <TextField
        {...omit(this.props, "onChange", "onUpdate")}
        inputPrefix={this.props.currency}
        ref={this.ref}
        value={this.state.value}
      />
    );
  }
}
